import React from 'react'
import { AuthRoles } from '../../Component/Auth/AuthRoles.js';

const MarketingRoute = [
    {
        path: '/marketing',
        component: React.lazy(() => import('./Marketing.js')),
        auth: AuthRoles.editor,
    }
]

export default MarketingRoute;